import { render, staticRenderFns } from "./RsaAccettazioneEditComponent.vue?vue&type=template&id=226622c0&scoped=true"
import script from "./RsaAccettazioneEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaAccettazioneEditComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaAccettazioneEditComponent.vue?vue&type=style&index=0&id=226622c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226622c0",
  null
  
)

export default component.exports